export const GET_COLLEGE_DEGREE = 'GET_COLLEGE_DEGREE';
export const LOADING_COLLEGE_DEGREE = 'LOADING_COLLEGE_DEGREE';
export const SAVE_LOADER_COLLEGE_DEGREE = 'SAVE_LOADER_COLLEGE_DEGREE'
export const FORM_FAIL = "FORM_FAIL";
export const COLLEGE_DEGREE_FAIL = 'COLLEGE_DEGREE_FAIL';